import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { withFirebase } from '../../Firebase';
import "./FinishCapsulesPage.css";
import DragScrollProvider from 'drag-scroll-provider';
import RatingCard from "./RatingCard";

class FinishCapsulesComponentBase extends Component {
    constructor(props) {
        super(props);
        this.state = { current_uid: '', capsules: [], finishCapsules: [] };
    }

    componentDidMount() {

        let uid;
        document.body.style.background = '#F8F9FB';
        if (this.props.firebase.auth.currentUser) {
            this.props.refreshTopBar(this.props.firebase.auth.currentUser)
            uid = this.props.firebase.auth.currentUser.uid
            this.setState({ current_uid: uid })
            this.props.firebase.db
                .collection("capsules")
                .where("assigneeId", "==", uid)
                .get()
                .then(querysnapshot => {
                    let capsules = querysnapshot.docs.map(doc => {
                        let data = doc.data()
                        return {
                            id: doc.id,
                            ...data
                        }
                    });
                    this.setState({ capsules: capsules })
                    let finish_cps = [];
                    capsules.forEach(capsule => {
                        if (capsule.status === "finish") {
                            finish_cps.push(capsule);
                        }
                    });
                    let sortedCapsules = this.sortCapsules(finish_cps)
                    this.setState({ finishCapsules: sortedCapsules })
                })
        }
    }

    sortCapsules = (capsules) => {
        return capsules.sort((capsuleA, capsuleB) => capsuleB.achievementDate - capsuleA.achievementDate)
    }

    render() {
        const { finishCapsules } = this.state
        let nbrCaps = finishCapsules.length
        return (
            <>
                <div hidden={nbrCaps > 0} className="text-center mt-5">
                    <h1 className="title-progress">Vous n'avez pas de capsules réalisées.</h1>
                </div>
                <div className="mt-4 d-flex idea-list pl-5">
                    <div>
                        <DragScrollProvider>
                            {({ onMouseDown, ref }) => (
                                <div className="d-flex idea-list finish-card-scrolling-wrapper"
                                    ref={ref}
                                    onMouseDown={onMouseDown}>
                                    {finishCapsules.map((capsule, index) => <div key={index} onClick={this.onOpen} className="mr-5">
                                        <RatingCard
                                            capsule={capsule}
                                            card={'account'}
                                            inAccount={true}
                                        />
                                    </div>)}
                                </div>
                            )}
                        </DragScrollProvider>
                    </div>
                </div>
            </>
        )
    }
}

const FinishCapsulesComponent = withRouter(withFirebase(FinishCapsulesComponentBase));

export default FinishCapsulesComponent;
export { FinishCapsulesComponentBase };